import { PlanStatus } from "../../types/plan";
import { UserActionTypes, UserState, UserAction } from "./types";

const initialState: UserState = {
  plans: [],
  planSerachTry: 0,
  planSearchInfo: {},
  claims: [],
  claimOptions: {
    materialTypes: [],
    manufacturers: [],
    colors: [],
    actionsTaken: [],
    specificDamages: [],
    howDidOccur: [],
    damageTypes: [],
    specificLocations: [],
  },
};

export const userReducer = (
  state: UserState = initialState,
  action: UserActionTypes
): UserState => {
  switch (action.type) {
    case UserAction.SET_PLANS: {
      const sortedActivePlans = action.payload
        ?.filter((plan) => plan.planStatus === PlanStatus.ACTIVE)
        .sort((planA, planB) => planA?.id - planB?.id);
      const sortedInActivePlans = action.payload
        ?.filter((plan) => plan.planStatus !== PlanStatus.ACTIVE)
        .sort((planA, planB) => planA?.id - planB?.id);
      const allPlans = [...sortedActivePlans, ...sortedInActivePlans];
      return {
        ...state,
        plans: allPlans,
      };
    }

    case UserAction.SET_CUSTOMER_SEARCH_INFO: {
      return {
        ...state,
        planSearchInfo: {
          ...action.payload,
        },
      };
    }

    case UserAction.CLEAR_CUSTOMER_SEARCH_INFO: {
      return {
        ...state,
        planSearchInfo: {},
      };
    }

    case UserAction.SET_CLAIM_OPTIONS: {
      return {
        ...state,
        claimOptions: action.payload,
      };
    }
    case UserAction.INCREASE_PLAN_SEARCH_TRY: {
      return {
        ...state,
        planSerachTry: state.planSerachTry + 1,
      };
    }
    case UserAction.RESET_PLAN_SEARCH_TRY: {
      return {
        ...state,
        planSerachTry: 0,
      };
    }

    case UserAction.CLEAR_CLAIM_OPTIONS: {
      return {
        ...state,
        claimOptions: {
          materialTypes: [],
          manufacturers: [],
          colors: [],
          actionsTaken: [],
          specificDamages: [],
          howDidOccur: [],
          damageTypes: [],
          specificLocations: [],
        },
      };
    }

    default:
      return state;
  }
};
